import { background, extendTheme} from "@chakra-ui/react"
import "@fontsource/roboto"


const Box ={
  baseStyle: {
   
    background: 'teal.400',
    m:4,
    p:4
  },
  // Styles for the size variations
  sizes: {
    sm: {
      fontSize: 'sm',
    
    },
    md: {
      fontSize: 'md',
      
    background: 'teal.400',
      width: "300px"
    },
    xl:{
      fontSize:'xl',
     
    }
  },
  
  variants: {},
  // The default `size` or `variant` values
  defaultProps: {
    width: "100px"
  },
}
const Heading = {

  baseStyle:{
    fontWeight: 500,
    fontFamily: "Roboto",
    mt:[4,6],
    mb:3
     },
  sizes: {
    sm: {
      fontSize: 'sm',
     
      
    },
    md: {
      fontSize: 'md',
    
     
    },
    xl:{
      fontSize:'xl',
     
    },

    '2xl':{
      fontSize:'2xl',
   
      
    }
  },
 variants:{ 
  MeH: {
    lineHeights:1.3,
    fontWeight:400,
    fontSize:['xl','1xl'],
    letterSpacing:['.09rem','.12rem'],
    p:3
   
    },
  Master: {
   fontSize:["9xl"],
   letterSpacing: ['.09rem','.07rem'],
   fontWeight:[900],
   color:"gray.900"
  }
   },
   defaultProps: {
     size:'2xl',
   }
  }

const Text = {

  baseStyle:{
    fontWeight: 400,
    fontSize:['md','lg','lg'],
    lineHeight: "1.5",
    my:3,
    fontFamily: "Roboto"
     },
   
  sizes: {
    sm: {
      fontSize: 'sm',
     
    },
    
    md: {
      fontSize: 'md',
     
    },
    xl:{
      fontSize:'xl',
     
    }
  },
 variants:{ 
  MeA: {
    // lineHeights:1.3,

    fontSize:['md','lg','xl','1xl'],
    px:0,
    mb:0,
   },
   Zitat: {
    fontStyle: 'italic',
    fontSize:["xl","2xl"]
   },
   Bildunter:{
    fontSize:'sm',
     py:"0",
    color: "gray.600",
    pl:"3"
   },
   MeinTitel: {
    lineHeights:1.3,
    fontSize:['lg','xl','1xl'],
    px:0,
    mb:0,
    color:"text"
   },
   VeA: {
    lineHeights:1.1,
    fontSize:['md','lg','xl'],
    px:0,
    py:0,
    mb:0,
    fontWeight: 300,
    }
   },
   defaultProps: {
    fontSize: '3xl'
  }
  }


  
  

export const theme = extendTheme({
  
components: {
 Text,
 Heading,
 Box,
 
 },
//  styles,
colors: {
  brand: {
    100: '#E0AAFF',
    200: '#C77DFF',
    300: '#9D4EDD',
    400: '#7B2CBF',
    500: '#5A189A',
    600: '#3C096C',
    700: '#240046',
    800: '#10002B',
    900: '#070014',
  },
},
fontSizes: {
  xs: '12px',
  sm: '14px',
  md: '16px',
  lg: '18px',
  xl: '20px',
  '2xl': '24px',
  '3xl': '28px',
  '4xl': '36px',
  '5xl': '48px',
  '6xl': '64px',
},
fontWeights: {
  normal: 400,
  medium: 500,
  bold: 700,
},
lineHeights: {
  normal: 'normal',
  none: '1',
  shorter: '1.25',
  short: '1.375',
  base: '1.5',
  tall: '1.625',
  taller: '2',
},
letterSpacings: {
  tighter: '-0.05em',
  tight: '-0.025em',
  normal: '0',
  wide: '0.025em',
  wider: '0.05em',
  widest: '0.1em',
},
breakpoints: ['30em', '48em', '62em', '80em'],

})


export default extendTheme(theme)